import React from "react";
import Grid from "@mui/system/Unstable_Grid/Grid";
import SelectDropDown from "../../reuseableComponents/SelectDropDown";

/**
 * Header shared by every Sales report: title, subtitle, report picker and the
 * report's own actions (Print / Export). Styles: .qv-sales-summary-header* in
 * SalesSummaryWorkspace.css (scoped to .qv-sales-reports-workspace), theme
 * tokens in SalesReportsWorkspace.css.
 */
const SalesReportHeader = ({
  title,
  subtitle,
  printNote = null,
  reportList,
  selectedReport,
  onReportChange,
  actions = null,
}) => (
  <Grid
    container
    sx={{ py: 2.5 }}
    className="qv-sales-summary-header bg-white border-b border-gray-200"
  >
    <Grid item xs={12}>
      <Grid
        container
        direction={{ xs: "column-reverse", md: "row" }}
        justifyContent="space-between"
        alignItems="center"
      >
        <Grid
          item
          className="qv-sales-summary-header__content"
          sx={{
            width: { xs: "100%", md: "100%" },
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            flexWrap: "wrap",
            alignItems: { xs: "start", md: "center" },
            gap: "0 20px",
            justifyContent: "space-between",
            px: { xs: 1, sm: 2.5 },
          }}
        >
          <div
            className="qv-sales-summary-header__identity"
            style={{ alignSelf: "center", flex: 1 }}
          >
            <h1 className="qv-sales-summary-header__title text-2xl sm:text-3xl">
              {title}
            </h1>
            {subtitle && (
              <p className="qv-sales-summary-header__subtitle text-gray-600 mt-1 text-sm sm:text-base">
                {subtitle}
              </p>
            )}
            {printNote}
          </div>
          <SelectDropDown
            sx={{ width: "100%", maxWidth: "22.7rem" }}
            listItem={reportList}
            onClickHandler={onReportChange}
            selectedOption={selectedReport}
            dropdownFor={"reportList"}
            title={"title"}
            className={
              "right-Sales-Reports-dropdown-android qv-sales-summary-report-select"
            }
            menuClassName="qv-sales-summary-report-menu"
          />
          <div className="qv-sales-summary-header__actions">{actions}</div>
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default SalesReportHeader;
